import React, { Suspense, useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';

// Lazy load pages
const HomePage = React.lazy(() => import('./pages/Home'));
const ServicesPage = React.lazy(() => import('./pages/Services'));
const ServiceDetailPage = React.lazy(() => import('./pages/ServiceDetail'));
const AboutPage = React.lazy(() => import('./pages/About'));
const ContactPage = React.lazy(() => import('./pages/Contact'));
const ProjectRequestPage = React.lazy(() => import('./pages/ProjectRequest'));
const GeoPage = React.lazy(() => import('./pages/GeoPage'));
const FAQPage = React.lazy(() => import('./pages/FAQ'));
const PortfolioPage = React.lazy(() => import('./pages/Portfolio'));
const BlogPage = React.lazy(() => import('./pages/Blog'));
const ImpressumPage = React.lazy(() => import('./pages/Legal/Impressum'));
const DatenschutzPage = React.lazy(() => import('./pages/Legal/Datenschutz'));
const CookiesPage = React.lazy(() => import('./pages/Legal/Cookies'));
const NotFoundPage = React.lazy(() => import('./pages/NotFound'));

const LoadingScreen = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="text-white text-2xl">Lädt...</div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Suspense fallback={<LoadingScreen />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/leistungen" element={<ServicesPage />} />
              <Route path="/leistungen/:serviceId" element={<ServiceDetailPage />} />
              <Route path="/ueber-uns" element={<AboutPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/projekt-anfragen" element={<ProjectRequestPage />} />
              <Route path="/webentwicklung-berlin" element={<GeoPage />} />
              <Route path="/webentwicklung-muenchen" element={<GeoPage />} />
              <Route path="/webentwicklung-koeln" element={<GeoPage />} />
              <Route path="/webentwicklung-frankfurt" element={<GeoPage />} />
              <Route path="/webentwicklung-hamburg" element={<GeoPage />} />
              <Route path="/webentwicklung-stuttgart" element={<GeoPage />} />
              <Route path="/webentwicklung-duesseldorf" element={<GeoPage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
          <Footer />
          <CookieBanner />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;